import appWithAI from '@devices/settings/device_settings/app_settings_temperature_with_ai.js';
import device_information from '@devices/settings/device_settings/device_information';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'ShellyBLUHT',
	friendly_name: 'BLU HT',
	category: 'sensor',
	family: 'sensor',
	isPM: false,
	modes: {
		sensor: {
			channels: 1,
			notifications: ['device_problem', 'lowBattery'],
			charts: true,
			bluetooth_settings: [{ title: 'security', component: 'security_ble' }],
			settings: [
				{
					title: 'sensor_settings',
					components: [{ title: 'temperature_unit', component: 'temperature_unit_g2' }],
				},
				appWithAI,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'firmware_version', component: 'firmware_update_ble' },
						{ title: 'factory_reset', component: 'factory_reset_ble' },
					],
				},
				device_information,
			],
		},
	},
};
